import React from "react";
import CandidateRegistration from "./components/CandidateRegistration";
import BulkUpload from "./components/BulkUpload";
import "./App.css";

const BULK_UPLOAD_PATH = "/internal/bulk-upload";

function App() {
  const isBulkUpload = window.location.pathname.startsWith(BULK_UPLOAD_PATH);

  return (
    <div className="App">
      <header className="app-header">
        <div className="header-content">
          <div className="header-logo-section">
            <img src="/neco.png" alt="NECO Logo" className="neco-logo" />
            <div className="header-text">
              <h1>NATIONAL EXAMINATIONS COUNCIL</h1>
              <h2>NECO Registration Portal</h2>
            </div>
          </div>
          <div className="header-nav">
            <a href="https://cbt.neco.gov.ng" className="home-btn" target="_blank" rel="noopener noreferrer">
              Home
            </a>
          </div>
        </div>
      </header>
      <main className="app-main">{isBulkUpload ? <BulkUpload /> : <CandidateRegistration />}</main>
      <footer className="app-footer">
        <p>&copy; 2025 National Examinations Council. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default App;
